import { memo } from 'react';
import { Box, styled } from '@material-ui/core';
import { SCheckbox, SHighlightText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { distances } from '@setvi/shared/styles';

export const CountChip = styled(Box)(({ theme }) => ({
  fontSize: 12,
  lineHeight: '16px',
  color: TextColor.SlateGrey,
  padding: theme.spacing(1, 2),
  border: '1px solid #AFBAC6',
  borderRadius: 16,
  fontWeight: 600
}));

interface StandardListProps {
  item: string;
  count?: number;
  searchQuery?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isChecked: boolean;
}

const getItemName = (item: string) => {
  if (item === 'true') return 'Yes';
  if (item === 'false') return 'No';

  return item;
};

export const StandardList = memo(
  ({
    item,
    count,
    searchQuery,
    onChange,
    isChecked = false
  }: StandardListProps) => (
    <Box
      display="flex"
      alignItems="center"
      gridGap="8px"
      paddingY={distances.px.base}>
      <SCheckbox
        size="small"
        color="primary"
        checked={isChecked}
        onChange={onChange}
      />
      <Box
        display="flex"
        alignItems="center"
        width="100%"
        justifyContent="space-between">
        <SHighlightText
          size="sm"
          lineHeight="20px"
          searchQuery={searchQuery}
          value={getItemName(item)}
        />
        {count && (
          <Box ml={2}>
            <CountChip>{count}</CountChip>
          </Box>
        )}
      </Box>
    </Box>
  )
);
